const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/collections/$id/$week/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/collections/$id/$week/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient,
      country
    } = context;
    return {
      id,
      dehydratedState: dehydrate(queryClient),
      country
    };
  }
});